/**
 * _calc_roof_pitch.js — browser mirror of application/utils/calculators/roof_pitch.py.
 *
 * Change this, roof_pitch.py and tests/fixtures/calculator_cases.json together.
 */

import { noAnswer, plainNumber, roundHalfUp } from "./_calc_math.js";

const STOCK_STEP_MM = 300;
const LOW_PITCH_DEGREES = 15;
const SIDES = { gable: 2, skillion: 1 };

function riseFor(v) {
    if (v.mode === "angle") return v.run * Math.tan(v.angle * Math.PI / 180);
    return v.rise;
}

export function calculate(v) {
    const rise = riseFor(v);
    const run = v.run;
    if (run <= 0) return noAnswer(["pitch", "rise", "rafter", "stock", "rafters"]);
    const pitch = Math.atan(rise / run) * 180 / Math.PI;
    const slope = Math.sqrt(rise * rise + run * run);
    const rafter = slope * (run + v.eave) / run;
    const stock = Math.ceil(roundHalfUp(rafter / STOCK_STEP_MM, 6)) * STOCK_STEP_MM;
    const perSide = v.spacing > 0 && v.building_length > 0
        ? Math.floor(roundHalfUp(v.building_length * 1000 / v.spacing, 6)) + 1
        : 0;
    const rafters = perSide * SIDES[v.roof];
    const warnings = [];
    if (pitch < LOW_PITCH_DEGREES) {
        warnings.push("Most roof tiles need a steeper pitch than this. Check the tile or "
                      + "sheet maker's minimum pitch before you build.");
    }
    const items = rafters > 0
        ? [{ description: `Rafters, ${plainNumber(stock / 1000)} m lengths`, quantity: rafters }]
        : [];
    return {
        outputs: { pitch: roundHalfUp(pitch, 1), rise: roundHalfUp(rise, 0),
                   rafter: roundHalfUp(rafter, 0), stock, rafters },
        items,
        warnings,
    };
}
